import { useId } from "react";

import { cn } from "@/lib/utils";

export function ConnectIcon({
  className,
  ...props
}: React.ComponentProps<"svg">) {
  const id = useId();

  return (
    <svg
      aria-hidden="true"
      className={cn("h-6 w-[25px] text-white", className)}
      fill="none"
      viewBox="0 0 25 24"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath={`url(#${id}a)`} fill="currentColor" filter={`url(#${id}b)`}>
        <path d="M12.42 15.09c.097.456-.18.904-.614 1.073-1.91.743-3.39 2.154-4.035 3.886-.384 1.032.54 1.951 1.64 1.951h10.957c1.1 0 2.025-.92 1.64-1.951-.645-1.731-2.125-3.143-4.034-3.886-.434-.169-.712-.617-.614-1.073a.993.993 0 01.247-.46c.713-.778 1.156-1.86 1.156-3.056 0-2.37-1.734-4.29-3.873-4.29-2.139 0-3.873 1.92-3.873 4.29 0 1.196.443 2.278 1.156 3.056.12.13.21.287.247.46z" />
        <path d="M5.778 9.627c.374-.145.612-.53.528-.921a.853.853 0 00-.212-.395c-.613-.668-.993-1.598-.993-2.626C5.1 3.65 6.59 2 8.428 2s3.327 1.65 3.327 3.685c0 .488-.086.953-.24 1.38-1.24 1.085-1.998 2.745-1.998 4.509 0 1.116.294 2.17.815 3.068h-6.61c-.946 0-1.74-.79-1.41-1.676.554-1.488 1.826-2.7 3.466-3.339zm5.604.127c1.493.665 2.642 1.818 3.162 3.212.33.886-.464 1.676-1.41 1.676h-.95l-.011-.011c-.713-.779-1.156-1.86-1.156-3.057 0-.65.131-1.267.365-1.82z" />
      </g>
      <defs>
        <clipPath id={`${id}a`}>
          <path d="M.166 0h24v24h-24z" fill="#fff" />
        </clipPath>
        <filter
          colorInterpolationFilters="sRGB"
          filterUnits="userSpaceOnUse"
          height="32"
          id={`${id}b`}
          width="31.861"
          x="-3.764"
          y="-4"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="3" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" />
          <feBlend
            in2="BackgroundImageFix"
            result="effect1_dropShadow_13643_16343"
          />
          <feBlend
            in="SourceGraphic"
            in2="effect1_dropShadow_13643_16343"
            result="shape"
          />
        </filter>
      </defs>
    </svg>
  );
}

export function ExploreIcon({
  className,
  ...props
}: React.ComponentProps<"svg">) {
  const id = useId();

  return (
    <svg
      aria-hidden="true"
      className={cn("h-[33px] w-7 text-white", className)}
      viewBox="0 0 28 33"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g filter={`url(#${id})`}>
        <path
          clipRule="evenodd"
          d="M14.005 22.41h-.841c-1.195 0-2.293-.703-2.633-1.849-1.142-3.85-1.637-9.977 2.319-14.069a1.603 1.603 0 012.31 0c2.128 2.2 2.968 4.988 3.113 7.694.124 2.328-.266 4.595-.794 6.375a2.46 2.46 0 01-.285.626c-.492.77-1.388 1.223-2.347 1.223h-.842zm.1-5.543h-.395c-.731 0-1.342-.459-1.41-1.06l-.072-.623a11.085 11.085 0 01-.066-1.593 3.64 3.64 0 01.768-2.099 1.48 1.48 0 012.352 0 3.64 3.64 0 01.767 2.098c.017.533-.005 1.065-.066 1.594l-.07.623c-.07.601-.68 1.06-1.412 1.06h-.395zm5.64-.419c1.277 2.578 1.658 5.566 1.571 7.914-.04 1.104-1.263 1.534-2.098.858a.902.902 0 01-.158-.172l-1.501-2.062a3.945 3.945 0 001.358-1.998c.379-1.277.706-2.844.827-4.54zm-11.479-.004c.122 1.697.449 3.266.828 4.544.248.838.736 1.51 1.357 1.997l-1.503 2.063a.901.901 0 01-.157.172c-.835.676-2.058.246-2.099-.858-.086-2.349.295-5.339 1.574-7.918zm3.822 7.158a1.2 1.2 0 000 2.4h3.835a1.2 1.2 0 000-2.4h-3.835z"
          fill="currentColor"
          fillRule="evenodd"
        />
      </g>
      <defs>
        <filter
          colorInterpolationFilters="sRGB"
          filterUnits="userSpaceOnUse"
          height="32.003"
          id={id}
          width="26.648"
          x="0.681"
          y="0"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="3" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" />
          <feBlend
            in2="BackgroundImageFix"
            result="effect1_dropShadow_8166_12048"
          />
          <feBlend
            in="SourceGraphic"
            in2="effect1_dropShadow_8166_12048"
            result="shape"
          />
        </filter>
      </defs>
    </svg>
  );
}

export function ProfileIcon({
  className,
  ...props
}: React.ComponentProps<"svg">) {
  return (
    <svg
      aria-hidden="true"
      className={cn("h-6 w-[25px] text-white", className)}
      viewBox="0 0 25 24"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        clipRule="evenodd"
        d="M13.361 2.036A10.362 10.362 0 0012.495 2c-1.366 0-2.652.26-3.86.782a10.332 10.332 0 00-3.191 2.162c-.92.92-1.64 1.983-2.162 3.19a9.632 9.632 0 00-.782 3.86c0 1.373.26 2.663.782 3.871a10.356 10.356 0 002.172 3.18c.92.92 1.98 1.64 3.18 2.162a9.55 9.55 0 003.871.793 9.525 9.525 0 003.86-.793 10.173 10.173 0 003.191-2.161c.92-.92 1.64-1.98 2.162-3.18a9.658 9.658 0 00.782-3.871c0-1.27-.229-2.472-.686-3.605A5.475 5.475 0 0118.5 9.5a5.475 5.475 0 01-2.828-.782c.126.38.189.782.189 1.208 0 .707-.151 1.341-.453 1.904a3.517 3.517 0 01-1.204 1.328 3.056 3.056 0 01-1.71.474 3.187 3.187 0 01-1.708-.495 3.622 3.622 0 01-1.214-1.317c-.296-.556-.443-1.187-.443-1.894 0-.659.147-1.263.443-1.812a3.62 3.62 0 011.214-1.317 3.105 3.105 0 011.709-.494c.39 0 .758.064 1.103.193A5.476 5.476 0 0113 4c0-.692.128-1.354.361-1.964zm-3.059 18.1a8.275 8.275 0 002.193.3c.734 0 1.465-.1 2.192-.3a8.752 8.752 0 002.059-.853 7.223 7.223 0 001.719-1.349 4.815 4.815 0 00-1.451-1.43 7.004 7.004 0 00-2.059-.907 9.478 9.478 0 00-2.46-.308c-.878 0-1.705.106-2.48.319a7.004 7.004 0 00-2.06.906 4.908 4.908 0 00-1.44 1.42c.5.528 1.073.978 1.718 1.349a8.95 8.95 0 002.07.854z"
        fill="currentColor"
        fillRule="evenodd"
      />
      <circle cx="18.5" cy="4" fill="#d72e2e" r="4" />
    </svg>
  );
}
